t = require('app/scripts/views/internal/teacup-with-helpers')('popover_change_roles')

module.exports = ->
  t.ul '.pop-over-list', ->

    t.li ->
      t.a { class: t.mustacheBlock('canMakeAdmin', (-> 'js-make-admin highlight-icon')) + t.mustacheBlockInverted('canMakeAdmin', (-> ' disabled')) }, ->
        t.check t.mustacheVar('memberIsAdmin'), 'admin'

        t.span '.sub-name', ->
          t.text t.mustacheVar('roleText_admin')

    t.li ->
      t.a { class: t.mustacheBlock('canMakeMember', (-> 'highlight-icon js-make-member ')) + t.mustacheBlockInverted('canMakeMember', (-> ' disabled')) }, ->
        t.check t.mustacheVar('memberIsNormal'), 'normal'
        t.span '.sub-name', ->
          t.text t.mustacheVar('roleText_normal')

    t.mustacheBlock 'showObserver', ->
      t.li ->
        t.a { class: t.mustacheBlock('canMakeObserver', (-> 'highlight-icon js-make-observer ')) + t.mustacheBlockInverted('canMakeObserver', (-> ' disabled')) }, ->
          t.format 'observer'
          t.icon 'business-class'
          t.mustacheBlock 'memberIsObserver', ->
            t.icon 'check'
          t.span '.sub-name', ->
            t.text t.mustacheVar('roleText_observer')

  t.mustacheBlockInverted 'isMoreThanOneAdmin', ->
    t.mustacheBlock 'memberIsAdmin', ->
      t.hr()
      t.p '.quiet.u-bottom', ->
        t.format 'you-can-t-change-roles-because-there-must-be-at-least-one-admin'
